"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LABEL_COLOR = exports.ICON = void 0;
const ICON = exports.ICON = {
  TYPE: 'CheckIcon',
  COLOR: 'greyDark',
  SIZE: 'titleNormal'
};
const LABEL_COLOR = exports.LABEL_COLOR = 'neutral';